<template>
  <div class="passenger-accordion-item">
    <button
      class="passenger-accordion-toggle"
      :aria-expanded="isOpen"
      @click="$emit('toggle')"
    >
      <div class="passenger-accordion-name">
        <strong>{{ title }}</strong>
        <strong class="passenger-accordion-passport">{{ passport }}</strong>
      </div>
      <i class="material-icons passenger-accordion-icon">
        {{ isOpen ? 'remove' : 'add' }}
      </i>
    </button>

    <b-collapse :visible="isOpen" role="tabpanel">
      <div class="passenger-accordion-body">
        <slot />
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'EntryReqsAccordion',
  props: {
    title: {
      type: String,
      required: true,
    },
    passport: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggle'],
}
</script>
